import UserRole from "enums/Role";
import UserStatus from "enums/UserStatus";

/**
 * The user-list filter set, declared once. Both `/admin/users` and
 * `/platform/users` had an identical copy of this type.
 */
export type UserFilterData = {
  userName?: string;
  role?: UserRole[];
  status?: UserStatus[];
  manager?: string;
  activeCards?: undefined | number;
  searchTerm?: string;
  companyId?: string;
};

/**
 * An empty array means "no constraint", not "nothing matches", so it has to
 * reach the query as `undefined`. Two different intentions cannot share one
 * representation.
 */
export const filterValues = <T>(values?: T[]): T[] | undefined =>
  values?.length ? values : undefined;

/** Company-level roles a user list can be filtered by. Platform roles are
 *  granted from the platform app and never appear on a company user. */
export const FILTERABLE_ROLES: UserRole[] = [
  UserRole.Cardholder,
  UserRole.Employee,
  UserRole.Contractor,
  UserRole.Manager,
  UserRole.Auditor,
  UserRole.Accountant,
  UserRole.Admin,
  UserRole.Owner,
];

/**
 * The statuses the list is constrained to. Deactivated users are hidden by
 * default; showing them means no status constraint at all, not a third status.
 * This is the two tabs it replaced, in one control.
 */
export const statusesFor = (showDeactivated: boolean): UserStatus[] =>
  showDeactivated ? [] : [UserStatus.ACTIVE, UserStatus.PENDING];
